<template>
  <div id="start-page-texts">
    <h5> {{ this.startPageStrings.title }} </h5>
    <div class="text-container" v-html="this.startPageStrings.paragraphOne"></div>
    <div class="text-container" v-html="this.startPageStrings.paragraphTwo"></div>
  </div>
</template>

<script>
export default {
  name: 'StartPageTexts',
  data () {
    return {
      msg: 'message'
    }
  },
  props: [],
  methods: {
  },
  beforeMount () {
  },
  computed: {
    pages () {
      return this.$store.state.pages
    },
    startPageStrings () {
      if (this.pages.length > 0) {
        return {
          // title: 'Vad är reformbanken?',
          // paragraphOne: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          // paragraphTwo: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
          title: this.pages[1].acf.title,
          paragraphOne: this.pages[1].acf.first_paragraph,
          paragraphTwo: this.pages[1].acf.second_paragraph
        }
      } else {
        return {
          title: '...',
          paragraphOne: '...',
          paragraphTwo: '...'
        }
      }
    }
  },
  components: {}
}
</script>

<style lang="scss">
#start-page-texts {
  margin: 0px 0px 40px 0px;
  width:100%;
  text-align: left;
  font-size: 16px;
  line-height: 23px;
  .text-container p:last-of-type {
    margin-top: 30px;
  }
}
@media #{$ipads} {
  #start-page-texts {
    width: 100%;
  }
}
@media #{$small-pads} {
  #start-page-texts {
    width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StartPageTexts.vue